import { IAccount } from 'shopify-payment-core'

import { useAccountRef } from './useAccountRef'
import { useSnackBar } from './useSnackBar'

type NullableAccount = { [P in keyof IAccount]?: IAccount[P] | null }

export function useAccountUpdate(account: IAccount, successText?: string) {
  const accountRef = useAccountRef(account)
  const { enqueueSuccess } = useSnackBar()
  return async (change: NullableAccount, successTextOverride?: string) => {
    await accountRef.update(change)
    const text = successTextOverride || successText
    if (text) {
      enqueueSuccess(text)
    }
  }
}
